import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DefaultErrorPropType } from 'app/lib/proptypes';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';
import { translateError } from 'app/lib/error';

export function GenericErrorNotification({
    id,
    onDismiss,
    error,
    i18nKey = null,
    i18nParams = null
}) {
    const { t } = useTranslation();
    const resolvedMessage = i18nKey
        ? t(i18nKey, {
              ...i18nParams,
              message: translateError(t, error)
          })
        : error?.message;
    return (
        <Snackbar
            id={id}
            onDismiss={onDismiss}
            variant={SnackbarVariant.ERROR}
            enableShowDetailsIfTruncated
            message={resolvedMessage}>
            <SnackbarMessage>{resolvedMessage}</SnackbarMessage>
        </Snackbar>
    );
}

GenericErrorNotification.propTypes = {
    id: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    i18nKey: PropTypes.string,
    error: DefaultErrorPropType.isRequired,
    i18nParams: PropTypes.shape({})
};
